import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.307 3.67a1.5 1.5 0 0 1 1.553.101l10 7a1.5 1.5 0 0 1 0 2.458l-10 7A1.5 1.5 0 0 1 5.5 19V5a1.5 1.5 0 0 1 .807-1.33M7 5v14l10-7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }